var $ = require('jquery');

$(function(){

  // ナビ開閉
  $('.js-st-Header__toggle').on('click', function(){
    $('.js-st-Header__nav').toggleClass('is-active');
  });

  // ナビリンククリック後、ナビ閉じる（ページ内リンク対応）
  $('.js-st-Header__nav a').on('click', function() {

    if($(this).hasClass('js-hide')) {
      $('.js-st-Header__nav').toggleClass('is-active');
    }

  });

});